import { GLOBALS, TenantKey } from './global.environment';
import { WorkRolesEnum, WorkUseremploymentSalaryIntervalEnum } from '@work-frontend-monorepo/work-rest-api';

export const SFG_GLOBALS = {
  ...GLOBALS,
  tenantKey: 'sfg' as TenantKey,
  tenantCompany: 'Safety First Gerüstbau AG',
  tenantCompanyCommonName: 'SFG',
  tenantAdministrationEmail: 'info@sfg-ag.ch',
  // Standort aus der Businessunit „Sissach" übernommen. Kein Maps-Link hinterlegt — die Adresse
  // wird dann ohne Link angezeigt.
  locations: [{ region: 'Sissach', street: 'Bahnhofstrasse 29', zipCity: '4450 Sissach/BL', mapsUrl: '' }],
  tenantLogoPath: 'assets/svg/sfg_logo_without_claim.svg',
  tenantOfficeLogoPath: 'assets/svg/sfg_logo_office.png',
  tenantFaviconPath: 'assets/favicons/sfg_favicon.png',
  i18nOverrideModule: 'SFG-OVERRIDES',
  // `akquise` bewusst nicht mehr: der Bereich zeigt bei SFG die Akquiseobjekte; Reservationen & Co. sperrt das
  // worksuite-admin-Modul `akquise` pro Unterseite.
  disabledModulesForTenant: ['screens', 'elektro-drittkontrolle', 'geruestbau', 'besprechungen', 'todos', 'einkauf', 'aufgaben', 'chats'],
  workOffice: {
    appName: 'SFG Office',
    topNavigationLogoVariant: 'default',
  },
  support: {
    ...GLOBALS.support,
    apiKey: 'dm_047b8a7a962a6e7f93ec7c938458f7629494b2754814e711',
    appName: 'SFG-Office',
    primaryColor: '#FFB500',
    title: 'Fehler entdeckt oder eine Frage zum SFG-Office?',
    subtitle: 'Beschreibe dein Anliegen – wir melden uns.',
  },
  standardCategoryIdForNewContacts: 2,
  useremploymentDefaults: {
    targetHours: 8.4,
    holidaysPerYear: 25,
    salaryInterval: WorkUseremploymentSalaryIntervalEnum.Months13,
  },
  workItemsKeysSolar: ['geruest-schraeg-solar', 'geruest-flach-solar'],
  workItemsKeysFassade: ['geruest-schraeg-fassade', 'geruest-flach-fassade'],
  workItemsKeysToDisplayDormers: ['geruest-schraeg-solar', 'geruest-schraeg-spengler', 'geruest-schraeg-dach'],
  workItemsKeyForOptionVorsprung: 'geruest-option-vorsprung',
  workItemsKeyForTower: 'geruest-option-turm',
  workItemsKeyForAufgang: 'geruest-option-aufgang',
  workItemsKeyForInstallationTower: 'geruest-schraeg-installationsturm',
  workItemsKeyForFlatSecurity: 'geruest-flach-absturzsicherung-seitlich',
  workItemsKeyForDormer: 'geruest-option-lukarn',
  workItemsKeyForSideFallProtection: 'geruest-schraeg-absturzsicherung-seitlich',
  workItemsKeyForFirstFallProtection: 'geruest-schraeg-absturzsicherung-first',
  workItemsKeyForRoofProtectionWall: 'geruest-dachdeckerschutzwand',
  workItemsKeyForKonsolen: 'geruest-konsolen',
  workItemsKeyForRowHouseFallProtection: 'geruest-schraeg-absturzsicherung-first',
  workItemsKeyForRowHouseSideFallProtection: 'geruest-schraeg-absturzsicherung-reihenhaus-seitlich',
  workItemsKeyForRoofInclinationOptions: [
    'geruest-dachneigung-10-30',
    'geruest-dachdeckerschutzwand',
    // Legacy keys kept for cleanup of old projects
    'geruest-dachneigung-0-15',
    'geruest-dachneigung-16-30',
    'geruest-dachneigung-31-45',
    'geruest-dachneigung-46-plus',
  ],
  workItemsForbiddenKeyForSolarOnly: [
    'geruest-schraeg-fassade',
    'geruest-schraeg-spengler',
    'geruest-schraeg-dach',
    'geruest-flach-fassade',
    'geruest-flach-spengler',
    'geruest-flach-dach',
  ],
  workProjectsStatusKeyEntwurf: 'Entwurf',
  workProjectStatusKeyAngefragt: 'Angefragt',
  workItemGroupDefault: 'sfg-gerueste',
  workItemGroupOptions: 'sfg-zuschlaege',
  /*
  Unique identifier for SFG Items must be:
  geruest-basis, geruest-schraeg-fassade, geruest-schraeg-solar, geruest-schraeg-spengler, geruest-schraeg-dach, geruest-flach-fassade, geruest-flach-solar, geruest-flach-spengler
  geruest-flach-dach, geruest-option-transport, geruest-option-glasdach, geruest-option-vordach, geruest-option-ueberbrueck, geruest-option-enge, geruest-option-garage,
  geruest-option-vorsprung, geruest-option-turm, geruest-option-lukarn, geruest-montage
   */
  workStates: {
    names: {
      favorites: 'sfg_state__favorite',
      filter: 'sfg_state__filter',
      loading: 'sfg_state__loading',
      profile: 'sfg_state__profile',
      reload: 'sfg_state__reload',
      widgets: 'sfg_state__widgets',
      terminAssistent: 'sfg_ta__state',
      sfgGeruest: 'sfg_geruest',
      tenants: 'sfg_state__tenants',
    },
  },
  showObjectAddressInsteadOfCustomer: true,
  montageplanShowExternalCustomerByDefault: true,
  standardTaskIdsToShowInAppDashboard: [18, 6],
  // Standardtask-IDs der SFG-Datenbank (nicht die Axova-IDs aus mandantenExterneProjekte)
  appProjectAssignmentTypes: [
    { label: 'MONTAGE', standardtaskIds: [15] },
    { label: 'DEMONTAGE', standardtaskIds: [16] },
    { label: 'TEILDEMONTAGE', standardtaskIds: [22] },
  ],
  // Vorerst nur für Superuser — die Kalkulation zeigt Einkaufs- und Verkaufspreise.
  appProjectCalculationRequiredRoles: [WorkRolesEnum.AxSuperuser],
  showMontageplanTasksOfNotSoldProjects: true,
  allowLockedMontageplanBlocksMoveOnYAxis: true,
  requireExternalProjectLead: true,
  useLoggedInUserAsDefaultProjectAdvisor: true,
  showSkontoPercentage: true,
  showDebtorSendInvoiceByMail: true,
  skipContactToLeadModal: true,
  mandantenExterneProjekte: {
    roletypeName: 'ax_extern_safetyfirstgeruestbau',
    calculationItemIds: '43,44,112,220,221,222',
    priceColumnLabel: 'PREIS',
    pageTitle: 'EXTERNE_PROJEKTE',
    taskColumns: [
      { label: 'GERUESTAUFBAU', standardtaskIds: [111, 127, 129] },
      { label: 'GERUESTABBAU', standardtaskIds: [112, 128, 130] },
    ],
  },
  firebaseWebPush: {
    apiKey: 'AIzaSyAowFlWHb196BVtu_WtSHUfrskCWyIgwTc',
    projectId: 'sfg-ag',
    messagingSenderId: '501350929889',
    appId: '1:501350929889:web:b81fa2e96c3627e40f6ea0',
    vapidKey: 'BJMHPM7rSOQqRo_iduv2ey-e0gGmxkc-psQx3YCKAwT0cZbFjRSXeWtwHGNpx5rG7wEPmpuIXLwBNvICp3xexUw',
  },
};
